var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{attrs:{"title":"项目权限","visible":_vm.drawer,"wrapperClosable":false,"size":"52%"},on:{"update:visible":function($event){_vm.drawer=$event},"open":_vm.open,"close":_vm.close}},[_c('div',{staticClass:"demo-drawer-content"},[_vm._v("11111111")])])
}
var staticRenderFns = []

export { render, staticRenderFns }